"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _RoutesProvider = require("../components/RoutesProvider");

var _extractPaths = _interopRequireDefault(require("../lib/extractPaths"));

/**
 * Returns all of the route paths within an app.
 *
 * @example
 * {
 * home: "/",
 * aboutUs: "/about-us",
 * services: {
 *  index: "/services",
 *   buy: "/services/buy",
 *  sell: {
 *    index: "/services/sell",
 *    sellItem: "/services/sell/:id"
 *  }
 * }
 * }
 */
var usePaths = function usePaths() {
  var paths = (0, _react.useContext)(_RoutesProvider.RoutesContext);
  return (0, _extractPaths["default"])(paths);
};

var _default = usePaths;
exports["default"] = _default;